import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';

// Lazy load: Always load Homepage
import AppHomePage from '@/views/AppHomePage.vue';

const routes = [
    {
        path: '/',
        name: 'AppHomePage',
        component: AppHomePage,
        meta: { title: 'Բոլոր ապրանքների գները մեկ հարթակում' },
    },
    {
        path: '/search',
        name: 'AppSearchPage',
        component: () => import(/* webpackChunkName: "AppSearchPage" */ '@/views/AppSearchPage.vue'),
        props: (route: RouteLocationNormalized) => ({
            query: route.query.query,
            limit: route.query.limit ? parseInt(route.query.limit as string) : null,
            page: route.query.page ? parseInt(route.query.page as string) : 1,
            type: route.query.type,
            similarity: route.query.similarity ? parseFloat(route.query.similarity as string) : null,
            distance: route.query.distance ? parseFloat(route.query.distance as string) : null,
        }),
        meta: { title: 'route.query.query' },
    },
    {
        path: '/about',
        name: 'AppAboutPage',
        component: () => import(/* webpackChunkName: "AppAboutPage" */ '@/views/AppAboutPage.vue'),
        meta: { title: 'Մեր մասին' },
    },
    {
        path: '/contact',
        name: 'AppContactPage',
        component: () => import(/* webpackChunkName: "AppContactPage" */ '@/views/AppContactPage.vue'),
        meta: { title: 'Հետադարձ կապ' },
    },
    {
        path: '/cooperation',
        name: 'AppCooperationPage',
        component: () => import(/* webpackChunkName: "AppCooperationPage" */ '@/views/AppCooperationPage.vue'),
        meta: { title: 'Համագործակցություն մեզ հետ' },
    },
    {
        path: '/internal-error',
        name: 'AppInternalErrorPage',
        component: () => import(/* webpackChunkName: "InternalErrorPage" */ '@/views/InternalErrorPage.vue'),
        meta: { title: 'Համակաչգի ներքին սխալ' },
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFoundPage',
        component: () => import(/* webpackChunkName: "NotFoundPage" */ '@/views/NotFoundPage.vue'),
        meta: { title: 'Էջը չի գտնվել' },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(_to, _from, savedPosition) {
        return (
            savedPosition ||
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve({ top: 0, behavior: 'smooth' });
                }, 300);
            })
        );
        // return savedPosition || {top: 0};
        // return {top: null, left: null, behavior: null};
    },
});

router.beforeEach((to, _from, next) => {
    to.matched
        .filter((record) => record.meta.title)
        .map((record) => {
            if (to.meta.title === 'route.query.query') {
                const query = to.query.query as string;
                let title = query.length > 0 ? query : 'Որոնում';

                document.title = `${title} - Online Markets`;
            } else {
                document.title = `${to.meta.title} - Online Markets`;
            }

            return record;
        });

    next();
})

export default router;
